module.exports = __webpack_public_path__ + "static/media/kocka2IUG.9c37891f.png";